import { axios } from './axios';

function DataURIToBlob(dataURI: string) {
  const splitDataURI = dataURI.split(',');
  const byteString =
    splitDataURI[0].indexOf('base64') >= 0
      ? atob(splitDataURI[1])
      : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

  return new Blob([ia], { type: mimeString });
}

export async function uploadImage(
  imgBase64: string,
  type: 'answer-sheet' | 'schema',
) {
  const file = DataURIToBlob(imgBase64);
  const formData = new FormData();
  formData.append('file', file, 'image.jpg');

  const headers = {
    'Content-Type': 'multipart/form-data',
    'folder-name': 'auto-grade/image/' + type,
  };

  try {
    const { data } = await axios.post('file_upload', formData, {
      headers,
    });

    return data;
  } catch (error) {
    console.log('data:', error);
    return null;
  }
}

export async function uploadImages(images: string[]) {
  return await Promise.all(
    images.map(async image => {
      if (image && !image.includes('mysoalan')) {
        const uploadedImage = await uploadImage(image, 'answer-sheet');

        if (uploadedImage && uploadedImage.url) {
          return uploadedImage.url as string;
        } else {
          return image;
        }
      } else {
        return image;
      }
    }),
  );
}
